import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopDevPageSide300x250Gak from './gak/DesktopDevPageSide300x250Atf';
import DesktopDevPageSide300x250Hashtag from './hashtag/DesktopDevPageSide300x250Atf';
const DesktopDevPageSide300x250Atf = ({ safety ='off' , safetyState  })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Hashtag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Gak, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopDevPageSide300x250Atf.displayName = 'DesktopDevPageSide300x250Atf';
export default DesktopDevPageSide300x250Atf;
